import { Component, inject, OnInit, DestroyRef, effect, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from '@shared/services/utils.service';
import { MapService } from '../../services/map.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatAutocomplete, MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PeliasService } from '@api/services';
import { Feature } from '@api/models';
import { CoreService } from '@core/services';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-map-header-component',
  standalone: true,
  imports: [CommonModule, MatDividerModule, MatButtonModule, MatIconModule, MatAutocompleteModule, MatInputModule, TranslocoPipe, ReactiveFormsModule],
  templateUrl: './map-header.component.html',
  styleUrls: ['./map-header.component.scss']
})
export class MapHeaderComponent implements OnInit {

  @ViewChild('toAutocomplete') toAutocompleteReference!: MatAutocomplete;
  @ViewChild('trigger') toAutocompleteTriggerReference!: MatAutocompleteTrigger;


  public coreService = inject(CoreService)

  public isMobile = inject(UtilsService).isMobile;
  public sidenavOpened = this.coreService.sidenavOpened;
  public mapService = inject(MapService);
  public mapLoaded = this.mapService.mapLoaded;
  public showingResults = this.mapService.showingResults;
  public peliasService = inject(PeliasService);
  public utilsService = inject(UtilsService);
  public toOption = this.coreService.selectedToOption;

  public loadingRouteResults = toSignal(this.coreService.loadingRouteResults);

  public loading = false;

  private destroyRef = inject(DestroyRef);

  public toOptions:Feature[] = [];

  public mapHeaderForm = new FormGroup({
    to: new FormControl(''),
  });

  public constructor() {
    effect(() => {
      const toValue = this.toOption();
      this.mapHeaderForm.controls.to.setValue(toValue?.properties.name ? toValue.properties.name : '', {emitEvent: false});
      if (!toValue) {
        this.toOptions = [];
        if (this.toAutocompleteReference) {
          this.utilsService.cleanAutocomplete(this.toAutocompleteReference);
        }
      }
    })
    effect(() => {
      if(this.loadingRouteResults()) {
        this.mapHeaderForm.disable();
      } else {
        this.mapHeaderForm.enable();
      }
    })
  }

  ngOnInit(): void {
    this.listenToChanges();
  }

  
  public toggleSidenav() {
    this.sidenavOpened.set(true);
  }

  private listenToChanges() {
    this.utilsService.applyRxJSOperatorsToFeatureAutocomplete(this.mapHeaderForm, 'to', this.toOption.asReadonly(), this.destroyRef)
    .pipe(tap(() => this.loading = true))
    .subscribe((features) => {
      this.loading = false;
      this.toOptions = features ?? [];
    });
  }

  public cleanFromButtonClicked(auto: MatAutocomplete) {
    this.toOptions = [];
    this.toOption.set(null);
    this.utilsService.cleanAutocomplete(auto);
    this.mapHeaderForm.reset();
  }

  public onOptionSelected(option: Feature) {
    this.toOption.set(option);
    this.toAutocompleteTriggerReference.closePanel();
    this.coreService.autocompleteFromWithCurrentUbication();
  }

  public routeOptionsClicked(auto: MatAutocomplete) {
    this.utilsService.cleanAutocomplete(auto);
    this.sidenavOpened.set(true);
    this.toAutocompleteTriggerReference.closePanel();
    const toValue = this.toOption();
    this.mapHeaderForm.controls.to.setValue(toValue?.properties.name ? toValue.properties.name : '', {emitEvent: false});
  }

  public pickOnMap(auto: MatAutocomplete) {
    this.utilsService.cleanAutocomplete(auto);
    this.coreService.createRouteFromClickOnMap();
  }
}
